'use strict';

import recommendations from './product/recommendations';
import {dialogSDK} from './product/dialogSDK';

export default {
    init: function () {
        if ($('.pt_order-confirmation').length) {
            recommendations.init();

            if (SitePreferences.DIALOG_SCRIPT_ENABLED) {
                dialogSDK.initPDP();
            }

            if (localStorage.getItem('storedproductid') && window.dialog && window.dialog.instance) {
                const items = (orderConfirmation.productLineItems || []).map(product => ({
                    productId: product.id,
                    quantity: product.quantity,
                    price: product.price,
                    variantId: product.productVariantID
                }));

                window.dialog.instance.registerSubmitCheckoutEvent({
                    orderValue: orderConfirmation.gross,
                    currency: orderConfirmation.currencyCode,
                    transactionId: orderConfirmation.transactionId,
                    items
                });

                let storedProductIds = JSON.parse(localStorage.getItem('storedproductid')) || [];

                // Remove all purchased product IDs from localStorage
                const purchasedProductIds = items.map(item => item.productId);

                storedProductIds = storedProductIds.filter(
                    id => !purchasedProductIds.includes(id)
                );

                localStorage.setItem(
                    'storedproductid',
                    JSON.stringify(storedProductIds)
                );
            }


            const keysToRemove = [
                'storeDetailsSection',
                'selectedStoreData',
                'royalMail-edit',
                'storedAddressData'
            ];
            keysToRemove.forEach(key => localStorage.removeItem(key));
        } else {
            return;
        }
    }
};
